import { render, staticRenderFns } from "./PhilosophyComponent.vue?vue&type=template&id=7bcd7087&scoped=true&"
import script from "./PhilosophyComponent.vue?vue&type=script&lang=js&"
export * from "./PhilosophyComponent.vue?vue&type=script&lang=js&"
import style0 from "./PhilosophyComponent.vue?vue&type=style&index=0&id=7bcd7087&prod&lang=css&"
import style1 from "./PhilosophyComponent.vue?vue&type=style&index=1&id=7bcd7087&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bcd7087",
  null
  
)

export default component.exports